import { taiko as viemTaiko } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const taiko = {
  displayName: 'Taiko',
  runtime: 'evm',
  viemChain: viemTaiko,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'taiko' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
